// HourCell — THE hours-quantity renderer. Tabular figures, 0-decimal display,
// exact value in the title when rounding hides precision.
//
// Extracted from two independent hand-rolled copies (product-cols.jsx's row
// render and ProductsView.jsx's footer total) that had already drifted apart
// on font-size — the same "one job, two components" pattern surface-map.js
// used to track for PathCrumbs/Breadcrumb, since merged into one Breadcrumb
// with a dense variant (2026-08-21). Navy stays the default color on purpose
// (Alex, 2026-08-20): hours is the one non-dollar quantity in a row of dollar
// amounts, and the accent is deliberate, not drift.
import { formatQty } from './formatMoney.js';

// ⚠ NO fontSize PROP (2026-10-12). This file was extracted to end a font-size drift,
// then kept a fontSize prop — and the footer total used it to drift again (13px
// hours beside 11px money). The size is part of the type: one size, here.
// check-style.mjs fails any call site that passes fontSize to a component.
const FONT_SIZE = 'var(--fs-small)';

export default function HourCell({ n, bold, color = 'var(--th-navy)' }) {
  if (n == null) return null;
  const num = Number(n);
  if (!Number.isFinite(num)) return null;
  return (
    <span
      title={Math.round(num) !== num ? String(num) : undefined}
      style={{ fontVariantNumeric: 'tabular-nums', fontWeight: bold ? 600 : undefined, fontSize: FONT_SIZE, color }}
    >
      {formatQty(num)}
    </span>
  );
}
